import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  MassSalesOrderMainteananceBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import CustomTable from "../gui_components/CustomTable.js";
class MassSalesOrderPrint extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass Sales Order Maintenance",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowProgressBarPopup: false,
      criteria: new SalesOrderSearchCriteria(),
      salesLineCriteria: new MassSalesOrderMainteananceBean(),
      inquiryDataList: [],
      isInquiryDatasFound: false,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      isDisableFields: false,
      isShowLookUp: true,
      isShowColorLookup: false,
      colorLookupHandler: null,
      progressLoadingText: "",
      moduleForPopup: [],
      isShowCustomerModule: false,
      isShowSalesOrderMaintenanceModule: false,
      isShowFabricStyleModule: false,
      isShowSalesOrderLinePopup: false,
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowPopUpAlert: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    ModuleUtils.getSalesOrderLineStatusList();
    this.initLookupHandlers();
  }
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  dateonChange = (e) => {
    let salesLineCriteria = this.state.salesLineCriteria;
    let tempData = { ...salesLineCriteria };
    tempData[e.target.name] = e.target.value;
    salesLineCriteria = tempData;
    this.setState({ salesLineCriteria: tempData });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    this.loadsalesOrderList(criteria);
  };
  loadsalesOrderList = (listRequest) => {
    if (SecurityAccessManager.MassSalesOrderInquiry_IsAccessible()) {
      SalesOrderService.getSalesOrderLinesForMassMaintenance(
        listRequest,
        this.loadSalesOrderPrintResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSalesOrderPrintResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.massSalesOrderBean)) {
        resultList = response.data.massSalesOrderBean;
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookUp: false,
        isShowColorLookup: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  clearCriteria = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
    });
  };
  resetInquiry = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
    });
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerName = "";
      criteria.customerCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.loadCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  loadCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.loadCustomerDetailResponse,
      this.errorCallBack
    );
  };
  loadCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.loadCustomerCodeResponse,
      this.errorCallBack
    );
  }
  loadCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.loadCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            isDisable: false,
            isShowLookUp: true,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  loadFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.loadFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.loadFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.loadFabricColourBySearchString(e.target.value);
    }
  };
  loadFabricColourBySearchString(searchString) {
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };

  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowCustomerModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowSalesOrderMaintenanceModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewsalesOrderModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderMaintenanceModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowSalesOrderLinePopup: isShowPopup,
    });
  };
  onSalesOrderLineClick = (e, data, rowData) => {
    if (e.detail == 1) {
      let salesLineCriteria = rowData;
      this.setState({
        isShowSalesOrderLinePopup: true,
        salesLineCriteria: salesLineCriteria,
      });
    }
  };
  updateSalesOrder = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowSalesOrderLinePopup: false,
        isShowProgressBarPopup: true,
        progressLoadingText: "Approving Sales Order...",
      });
      let salesLineCriteria = this.state.salesLineCriteria;
      this.updateSalesOrderList(salesLineCriteria);
    }
  };
  updateSalesOrderList = (listRequest) => {
    if (SecurityAccessManager.MassSalesOrderInquiry_IsAccessible()) {
      SalesOrderService.updateExistringSalesOrderDate(
        listRequest,
        this.loadupdateSalesOrderResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadupdateSalesOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null) {
      this.showInfoMessage(response.data);
      this.loadPage();
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };

  columnDefinitions_V1 = () => {
    const columns = new Array();


    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Ln", "salesOrderLineNumber",
          true,
        )
        .setClickDetails(true, false, this.onSalesOrderLineClick, null)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          " Sales Order", "salesOrderNumber",
          true,
        )
        .setClickDetails(true, false, this.viewsalesOrderModule, null)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Cust Po", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode", true)
        .setClickDetails(true, false, this.viewFabricModule, null)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color Code", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getCaption)

    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Start Date", "salesOrderStartDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Stop Date", "salesOrderStopDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );


    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getSalesOrderLineStatusCaption(status);
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let salesLineCriteria = this.state.salesLineCriteria;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          fabricCodeRef={this.fabricCodeRef}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />
        {this.state.isInquiryDatasFound && (
          <>
            <Row>
              <FormLabel className="table-title">Sales DataList </FormLabel>
            </Row>
            {/* 
                <div className="mt-3">
                                  <CustomTable
                                    data={inquiryDataList}
                                    columns={this.columnDefinitions_V1()}
                                    label={"Sales DataList"}
                                  // isSortedData={true}
                                  // label={
                                  //   this.state.is3PL ? "Choose Inventory Lines" : "RollLines"
                                  // }
                                  // onSortComplete={(sortedData, sortConfig) => {
                                  //   this.setState({ pt_rollLines: sortedData });
                                  // }}
                                  />
                                </div> */}
            <div className="div_default">
              <Table id="fabrics_tables">
                <thead>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderLineNumber")
                    }
                  >
                    Ln
                    {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderLineNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderNumber")
                    }
                  >
                    Sales Order
                    {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "customerPurchaseOrderNumber")
                    }
                  >
                    Cust Po
                    {this.state.order === "desc" &&
                      this.state.sortField === "customerPurchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerCode")}
                  >
                    Customer
                    {this.state.order === "desc" &&
                      this.state.sortField === "customerCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "customerName")}
                  >
                    Customer Name
                    {this.state.order === "desc" &&
                      this.state.sortField === "customerName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "fabricStyleCode")
                    }
                  >
                    {this.state.is3PL ? "Item#" : "FabricStyle#"}
                    {this.state.order === "desc" &&
                      this.state.sortField === "fabricStyleCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "fabricStyleName")
                    }
                  >
                    Name
                    {this.state.order === "desc" &&
                      this.state.sortField === "fabricStyleName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "colorCode")}>
                    Color Code
                    {this.state.order === "desc" &&
                      this.state.sortField === "colorCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "lineStatus")}
                  >
                    Status
                    {this.state.order === "desc" &&
                      this.state.sortField === "lineStatus" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderStartDate")
                    }
                  >
                    Start Date
                    {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderStartDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "salesOrderStopDate")
                    }
                  >
                    Stop Date
                    {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderStopDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {inquiryDataList.map((data, index) => (
                    <tr key={index}>
                      <td className="text-right">
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.onSalesOrderLineClick(
                              e,
                              data.salesOrderLineNumber,
                              data
                            )
                          }
                        >
                          {<div>{index + 1}</div>}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewsalesOrderModule(e, data.salesOrderNumber)
                          }
                        >
                          {data.salesOrderNumber}
                        </Button>
                      </td>
                      <td>{data.customerPurchaseOrderNumber} </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerModule(e, data.customerCode)
                          }
                        >
                          {data.customerCode}
                        </Button>
                      </td>
                      <td> {data.customerName} </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewFabricModule(e, data.fabricStyleCode)
                          }
                        >
                          {data.fabricStyleCode}
                        </Button>
                      </td>
                      <td> {data.fabricStyleName} </td>
                      <td> {data.colorCode} </td>
                      <td className="summary_input text-right">
                        {ModuleUtils.getSalesOrderLineStatusCaption(
                          data.lineStatus
                        )}
                      </td>
                      <td> {ModuleUtils.getDateFormat_v1(data.salesOrderStartDate)} </td>
                      <td> {ModuleUtils.getDateFormat_v1(data.salesOrderStopDate)} </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {inquiryDataList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          </>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          popupLvlClass={"popupSizeLeve11"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesOrderMaintenanceModule}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSalesOrderLinePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel4"}
          title={"Sales Order Date Entry"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopUpAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.updateSalesOrder(e)}
              >
                update
              </Button>
            </div>
          }
          content={
            <div className="sales_line_pop">
              <Row>
                <Col sm="2">
                  <FormLabel>SalesOrder</FormLabel>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    value={salesLineCriteria.salesOrderNumber}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <FormLabel>Start Date</FormLabel>
                </Col>
                <Col sm="3">
                  <DatePickerComponent_adv
                    name="salesOrderStartDate"
                    value={salesLineCriteria.salesOrderStartDate}
                    onChange={this.dateonChange}
                  />
                </Col>
                <Col sm="2">
                  <FormLabel>Stop Date</FormLabel>
                </Col>
                <Col sm="3">
                  <DatePickerComponent_adv
                    name="salesOrderStopDate"
                    value={salesLineCriteria.salesOrderStopDate}
                    onChange={this.dateonChange}
                  />
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  let criteria = props.criteria;
  const onChange = (e) => props.onChange(e);
  const customerCodeRef = props.customerCodeRef;
  let colorCodeRef = React.createRef();
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricCodeRef = props.fabricCodeRef;
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            placeholder="Customer"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={props.isShowLookUp}
            showCriteriaDialog={true}
            lookupHandler={props.customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            disabled={true}
            name="customerName"
            placeholder="Customer Name"
            onChange={onChange}
            value={criteria.customerName}
          />
        </Col>
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricSTyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            placeholder={props.is3PL ? "Item" : "Fabric Style"}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookUp}
            showCriteriaDialog={true}
            onChange={fabricCodeOnChange}
            lookupHandler={props.fabricLookupHandler}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            disabled={true}
            name="fabricStyleName"
            placeholder="Name"
            onChange={onChange}
            value={criteria.fabricStyleName}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          <FormLabel> Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="fabricStyleColorCode"
            placeholder="color"
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function MassSalesOrderPrintModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <MassSalesOrderPrint {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default MassSalesOrderPrintModule;
